/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface TelefoneProps {
  telefone: string | null;
  telefonePrincipal: boolean;
  codigoCampoTelefone: number;
}

interface BodyProps {
  telefones: TelefoneProps[];
  idLead: string;
}

interface Params {
  idLeadCorretor: string;
  body: BodyProps;
}

export function useAlterarTelefones(props: Params) {
  const registerData = async () => {
    const ALTERAR_TELEFONES = `${leadsWebEnviroment}/commom/leads/alterar-telefones/v1/${props?.idLeadCorretor}`;
    return await instance.put(ALTERAR_TELEFONES, props?.body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["alterar_telefones"],
    onSuccess: () => {
      toast.success("Telefones alterados com sucesso", {
        autoClose: 10000,
      });
    },
    onError: (error: any) => {
      const errorMessages = error.response.data.notifications.map(
        (item: any) => `\n${item?.message}\n`
      );

      toast.error(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
